import React from 'react';

const ActionButtons = ({
  setShowCreateStorePopup,
  setShowUploadPopup,
}) => (
  <div style={{ display: 'flex', gap: '10px' }}>
    <button
      onClick={() => setShowCreateStorePopup(true)}
      style={{
        padding: '8px 16px',
        border: 'none',
        borderRadius: '20px',
        backgroundColor: '#E6E6FA',
        color: '#2D3E50',
        cursor: 'pointer',
        fontSize: '16px',
        fontWeight: 'bold',
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
      }}
    >
      <span style={{ fontSize: '18px', lineHeight: '1' }}>+</span> New Store
    </button>
    <button
      onClick={() => setShowUploadPopup(true)}
      style={{
        padding: '8px 16px',
        border: 'none',
        borderRadius: '20px',
        backgroundColor: '#E6E6FA',
        color: '#2D3E50',
        cursor: 'pointer',
        fontSize: '16px',
        fontWeight: 'bold',
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
      }}
    >
      <span style={{ fontSize: '18px', lineHeight: '1' }}>+</span> Add Item
    </button>
  </div>
);

export default ActionButtons;